import * as R from 'ramda';

const getEmptyValues = ([, values]) => R.isEmpty(values);
const getOmittedTags = ([name]) => ['distance', 'company'].includes(name);

export const cleanList = R.compose(R.reject(getOmittedTags), R.reject(getEmptyValues), R.toPairs);

export const extractFiltersFromQueryUnflattened = (accum, { query }) =>
  R.compose(R.mergeDeepWith(R.union, accum), R.fromPairs, cleanList)(query?.filters ?? query?.filter);

export const filterSearchQuery = R.pick(['keywords', 'location', 'radius']);

export const cleanObject = (formData) =>
  R.keys(formData).reduce((result, key) => {
    if (formData[key]) result[key] = formData[key];
    return result;
  }, {});

const locationValue = ({ location, radius }) => `${location}${radius ? ` (${radius} km)` : ''}`;

export const generateSummary = ({ keywords, location, radius }) =>
  R.join(', ', R.filter(R.identity, [keywords, location && locationValue({ location, radius })]));
